<div class="flex-display history-breadcrumb"  tabindex="0" *ngIf="crumbData.length !=0">
  <div *ngFor="let breadcrumbParts of crumbData">
    <span *ngIf="breadcrumbParts != crumbData[crumbData.length-1]" class="font-14">
      {{breadcrumbParts}}
      <span *ngIf="breadcrumbParts != crumbData[crumbData.length-2]"><img class="breadcrumbArrow overlay-bread-crumb-icon bread-crumb-Arrow" src="../../../../assets/icons/Arrow Right (Alt).svg" alt="Arrow Right"></span>
      <span *ngIf="breadcrumbParts == crumbData[crumbData.length-2]"><img class="breadcrumbArrow overlay-bread-crumb-icon bread-crumb-Arrow" src="../../../../assets/icons/Arrow RightDown (Alt).svg" alt="Arrow Down"></span>
    </span>
  </div>
</div>
